import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import PageTitle from '../../common/page-title';
import { Row, Col } from 'react-bootstrap';
import ArrowButton from '../../common/button-arrow';
import { getStockItIncentives } from '../../../actions/stock-it-incentives';
import StockItIncentivesList from "./stock-it-incentives-list";

import './styles.css';

class StockItIncentives extends Component {
  componentWillMount() {
    const { dispatch } = this.props;

    dispatch(getStockItIncentives());

    this.state = {
      pageNumber: 1
    };
  }

  handlePageChange = (page, size) => {
    this.setState({ pageNumber: page }, () => this.props.dispatch(getStockItIncentives(page)));
  };

  render() {
    return (
      <div className="container-fluid incentives">
        <Row>
          <PageTitle>Stock It Incentives</PageTitle>
          <Col md={12}>
            <Row>
              <Link to="/admin/stock_it_incentives/new">
                <ArrowButton color="red"
                             arrow={false}
                             submit={false}
                             permissions={{
                               action: "create",
                               subjectClass: "StockItIncentive",
                             }}
                             className="add-incentive">
                  New Stock It Incentive
                </ArrowButton>
              </Link>
            </Row>
          </Col>
          <Row>
            <Col md={12}>
              <StockItIncentivesList
                incentives={this.props.incentives}
                fetching={this.props.fetching}
                fetched={this.props.fetched}
                pagination={this.props.pagination}
                onPageChange={this.handlePageChange}
                currentPage={this.state.pageNumber}/>
            </Col>
          </Row>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    incentives: state.stockItIncentives.stock_it_incentives,
    fetching: state.stockItIncentives.fetching,
    fetched: state.stockItIncentives.fetched,
    pagination: state.stockItIncentives.paging,
  };
};

export default connect(mapStateToProps)(StockItIncentives);



// WEBPACK FOOTER //
// ./src/components/admin/stock-it-incentives/index.jsx